import { Head, usePage } from '@inertiajs/react'
import type { ReactNode } from 'react'
import AppLayout from '@/components/AppLayout'
import WikiLayout from '@/components/WikiLayout'
import type { WikiPageShowPageProps } from '@/types'

function WikiPageShow() {
  const { project, wiki_page, wiki_pages } = usePage<WikiPageShowPageProps>().props

  return (
    <>
      <Head title={`${wiki_page.title} - Wiki - ${project.name}`} />
      <WikiLayout
        project={project}
        wikiPage={wiki_page}
        wikiPages={wiki_pages}
      />
    </>
  )
}

WikiPageShow.layout = (page: ReactNode) => <AppLayout padding={0}>{page}</AppLayout>

export default WikiPageShow
